<template>
  <div :class="[style.block, style.offPaddingTop]">
    <InputStyle
      description="Заголовок"
      placeholder="Введите заголовок"
      size="M"
      textarea
      :modelValue="questionTitle"
      @update:modelValue="setQuestionTitle"
    />
  </div>

  <div :class="style.block">
    <InputStyle
      description="Описание"
      placeholder="Введите описание"
      size="M"
      textarea
      :modelValue="questionDescription"
      @update:modelValue="setQuestionDescription"
    />
  </div>

  <div :class="style.block">
    <InputStyle
      description="Текст"
      placeholder="Введите текст"
      size="M"
      :modelValue="questionText"
      @update:modelValue="setQuestionText"
    />
  </div>

  <div :class="style.block">
    <InputStyle
      description="Текст под кнопкой"
      placeholder="Введите текст"
      :modelValue="textBellowButton"
      @update:modelValue="setTextBellowButton"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

import style from "../../QuestionPanelComponent.module.scss";

import {questions} from "@/page/quiz/typeQuiz";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

export default defineComponent({
  name: "TextQuestionContent",

  components: {
    InputStyle
  },

  props: {
    question: {
      type: Object as PropType<questions | null>,
      default: null
    },

    questionIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      style
    };
  },

  methods: {
    setQuestionTitle(value: string): void {
      if (!this.question) {
        return;
      }

      this.question.question = value;
    },

    setQuestionDescription(value: string): void {
      if (!this.question) {
        return;
      }

      if (!this.question?.contacts) {
        this.question.contacts = {
          paragraph: ""
        };
      }
      this.question.contacts.paragraph = value;
    },

    setQuestionText(value: string): void {
      if (!this.question) {
        return;
      }

      this.question.placeholder = value;
    },

    setTextBellowButton(value: string): void {
      if (!this.question) {
        return;
      }

      modifyQuiz("set", value, ["textBellowButton"]);
    }
  },

  computed: {
    questionTitle(): string {
      return this.question?.question || "";
    },

    questionDescription(): string {
      return this.question?.contacts?.paragraph || "";
    },

    questionText(): string {
      return this.question?.placeholder || "";
    },

    textBellowButton(): string {
      return modifyQuiz("get", "", ["textBellowButton"]);
    }
  }
});
</script>
